import React from 'react';
import PropTypes from 'prop-types';
import {ApolloConsumer, Query} from 'react-apollo';
import gql from 'graphql-tag';
import {NetworkError} from 'components/GraphQLError/NetworkError';
import {normalizeObject} from 'utils/misc';
import throttle from 'lodash.throttle';


export const CHECK_LOGGED_IN = gql`
query checkLoggedIn {
  me {
    id
    email
    language
    permissions
    isSuperUser
    employmentOrganizations {
      id
      name
      isAccepted
    }
    applications {
      edges {
        node {
          id
        }
      }
    }
  }
  authenticatedOrganization {
    id
  }
}
`;

export const SET_USER_LAST_SEEN = gql`
mutation setUserLastSeen {
  setUserLastSeen {
    ok
    errorMessage
  }
}
`;


const setUserLastSeen = (apolloClient) => {
    apolloClient.mutate({mutation: SET_USER_LAST_SEEN}).catch(error => {
        console.error(error);
    });
};

const maxWaitMs = 5000;
const throttledSetUserLastSeen = throttle(setUserLastSeen, maxWaitMs, {leading: true, trailing: false});


export class WithCheckLoggedIn extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        onError: PropTypes.func
    };

    static defaultProps = {
        onError: (error, refetch) => <NetworkError error={error} refetch={refetch}/>,
        redirectToLoginWhenNotLoggedIn: false
    };

    constructor(props) {
        super(props);

    }

    onCompleted = (client, data) => {
        if (!data.me) {
            // Skip if not logged in
            throttledSetUserLastSeen.cancel();
            return;
        }

        throttledSetUserLastSeen(client);
    };

    render() {

        return (
            <ApolloConsumer>
                {(client) => (
                    <Query
                        query={CHECK_LOGGED_IN} onCompleted={this.onCompleted.bind(null, client)} notifyOnNetworkStatusChange={true}>
                        {({error, loading, data, refetch}) => {
                            if (error) {
                                return this.props.onError(error, refetch);
                            }

                            const {me, authenticatedOrganization} = data;
                            const user = me ? normalizeObject(me) : null;
                            const organizationId = authenticatedOrganization ? authenticatedOrganization.id : null;
                            const organizations = user ? user.employmentOrganizations : [];
                            const applications = user ? user.applications : [];

                            return this.props.children({
                                isLoggedIn: !!user,
                                selectedOrganizationId: organizationId,
                                user: user,
                                organizations: organizations,
                                applications: applications,
                                loading: loading,
                                refetchLoginStatus: refetch
                            });
                        }}
                    </Query>
                )}
            </ApolloConsumer>
        );
    }
}
